export default __webpack_public_path__ + "static/media/303.7ee31241.svg";